import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import { localize } from 'helpers/translator'
import interactiveVideoActions from 'redux/actions/interactiveVideoActions'

import Confirm from 'views/confirm/confirm'

class IVideoCreationActivityDeleteConfirm extends PureComponent {
	render() {
		return (
			<Confirm
				btOne={localize('global_no')}
				btTwo={localize('interactive_video_activity_delete_confirm')}
				alertMessage={localize('interactive_video_activity_delete_confirmation')}
				actionOne={this.props.actions.cancelActivityDelete}
				actionTwo={this.props.actions.confirmActivityDelete}
				closeAction={this.props.actions.cancelActivityDelete}
				actionButtonType={1}
			/>
		)
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		confirmActivityDelete:
			interactiveVideoActions.activityDeleteConfirmed,
		cancelActivityDelete:
			interactiveVideoActions.activityDeleteCanceled,
	}, dispatch)
}

IVideoCreationActivityDeleteConfirm.propTypes = {
	actions: PropTypes.shape({
		confirmActivityDelete: PropTypes.func.isRequired,
		cancelActivityDelete: PropTypes.func.isRequired,
	}),
}

export default connect(null, mapDispatchToProps)(
	IVideoCreationActivityDeleteConfirm
)

export { IVideoCreationActivityDeleteConfirm }
